import styles from './styles.module.scss';

export type SelectionItem = {
    id: any;
    image?: string;
    name: string;
    description?: string;
};

export interface SelectionListItemProps extends React.HTMLAttributes<HTMLDivElement> {
    image?: string;
    name: string;
    description?: string;
    isSelected?: boolean;
}

export const SelectionListItem = ({
    image,
    name,
    description,
    isSelected,
    ...rest
}: SelectionListItemProps) => {
    return (
        <div className={`${styles.wrapper} ${isSelected && styles.selected}`} {...rest}>
            {image && <img className={styles.image} src={image} alt={`Imagem de ${name}`} />}

            <div className={styles.details}>
                <div className={styles.name}>{name}</div>
                <small className={styles.description}>{description}</small>
            </div>
        </div>
    );
};
